import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
	Row,
	Col,
	Alert,
	Card,
	CardBody,
	Container,
	FormFeedback,
	Input,
	Label,
	Form,
	Spinner,
} from 'reactstrap';

//redux
import { useSelector, useDispatch } from 'react-redux';

import { Link, useNavigate } from 'react-router-dom';
import withRouter from '../../Components/Common/withRouter';

// Formik Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

// action
import { userForgetPassword } from '../../slices/thunks';

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from '../../assets/images/logo-light.png';
import ParticlesAuth from '../AuthenticationInner/ParticlesAuth';
import { createSelector } from 'reselect';
import AuthSlider from './authCarousel';
import LoginButtonMicrosoft from './LoginButtonMicrosoft';
import { baseSettingsColor } from '../../slices/thunks';

const ForgetPasswordPage = props => {
	document.title = 'SPED - Resetear Contraseña';

	const dispatch = useDispatch();
	const [isSubmitting, setIsSubmitting] = React.useState(false);
	const navigate = useNavigate();

	const selectorColor = createSelector(
		state => state.Settings,
		data => ({
			itemSettingsColor: data.itemSettingsColor,
		})
	);
	const { itemSettingsColor } = useSelector(selectorColor);
	useEffect(() => {
		dispatch(baseSettingsColor());
	}, []);

	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			email: '',
		},
		validationSchema: Yup.object({
			email: Yup.string()
				.email('Por favor, ingrese un correo electrónico válido')
				.required('Por favor, ingrese su correo electrónico'),
		}),
		onSubmit: async values => {
			setIsSubmitting(true);

			values.email = values.email?.toLowerCase();

			try {
				const response = await dispatch(
					userForgetPassword(values, props.router.location.pathname)
				);
				if (response.success) {
					navigate('/login');
				}
			} finally {
				setIsSubmitting(false);
			}
		},
	});

	const selectLayoutState = state => state.ForgetPassword;
	const selectLayoutProperties = createSelector(selectLayoutState, state => ({
		forgetError: state.forgetError,
		forgetSuccessMsg: state.forgetSuccessMsg,
		disabledUser: state.disabledUser,
	}));
	const { forgetError, forgetSuccessMsg, disabledUser } = useSelector(
		selectLayoutProperties
	);

	return (
		<React.Fragment>
			<div className='auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100'>
				<div className='bg-overlay'></div>
				<div className='auth-page-content overflow-hidden pt-lg-5'>
					<Container>
						<Row>
							<Col lg={12}>
								<Card className='overflow-hidden'>
									<Row className='g-0'>
										<AuthSlider />
										<Col lg={6}>
											<div className='p-lg-5 p-4'>
												<div className='text-center mt-2'>
													<h5 className='text-primary'>
														¿Has olvidado tu contraseña?
													</h5>
													<p className='text-muted'>
														Restablecer contraseña
													</p>

													<lord-icon
														src='https://cdn.lordicon.com/rhvddzym.json'
														trigger='loop'
														colors='primary:#0ab39c'
														className='avatar-xl'
														style={{
															width: '120px',
															height: '120px',
														}}
													></lord-icon>
												</div>

												<Alert
													className='border-0 alert-warning text-center mb-2 mx-2'
													role='alert'
												>
													¡Ingresa tu correo electrónico y te
													enviaremos las instrucciones!
												</Alert>
												<div className='p-2'>
													{(forgetError ||
														forgetSuccessMsg ||
														disabledUser) && (
														<Alert
															color={
																forgetSuccessMsg
																	? 'success'
																	: 'danger'
															}
															style={{ marginTop: '13px' }}
														>
															{disabledUser
																? 'No se puede recuperar la contraseña de un usuario deshabilitado'
																: forgetError
																? forgetError
																: forgetSuccessMsg}
														</Alert>
													)}
													<Form
														onSubmit={e => {
															e.preventDefault();
															validation.handleSubmit();
															return false;
														}}
													>
														<div className='mb-4'>
															<Label className='form-label'>
																Correo electrónico
															</Label>
															<Input
																name='email'
																className='form-control'
																placeholder='Ingresa tu correo electrónico'
																type='email'
																onChange={
																	validation.handleChange
																}
																onBlur={validation.handleBlur}
																value={
																	validation.values.email || ''
																}
																invalid={
																	validation.touched.email &&
																	validation.errors.email
																		? true
																		: false
																}
															/>
															{validation.touched.email &&
															validation.errors.email ? (
																<FormFeedback type='invalid'>
																	<div>
																		{validation.errors.email}
																	</div>
																</FormFeedback>
															) : null}
														</div>

														<div className='text-center mt-4'>
															<button
																type='submit'
																className='btn btn-label btn-primary w-50'
																style={{
																	backgroundColor:
																		itemSettingsColor?.primary_color,
																	borderColor:
																		itemSettingsColor?.primary_color,
																}}
																disabled={
																	isSubmitting ||
																	!validation.isValid
																}
															>
																{isSubmitting ? (
																	<i className='label-icon'>
																		<Spinner size='sm' />
																	</i>
																) : (
																	<i className='ri-lock-unlock-line label-icon'></i>
																)}{' '}
																Enviar enlace de reinicio
															</button>
														</div>
													</Form>
												</div>

												<div className='mt-4 text-center'>
													<p className='mb-0'>
														Espera, recuerdo mi contraseña{' '}
														<Link
															to='/login'
															className='fw-semibold text-primary text-decoration-underline'
														>
															{' '}
															Click{' '}
														</Link>{' '}
													</p>
												</div>
											</div>
										</Col>
									</Row>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
				{/* <footer className='footer'>
					<Container>
						<Row>
							<Col lg={12}>
								<div className='text-center ff-bas fs-12 fw-medium text-uppercase text-muted'>
									<p className='mb-0'>
										&copy; {new Date().getFullYear()}
									</p>
								</div>
							</Col>
						</Row>
					</Container>
				</footer> */}
			</div>
		</React.Fragment>
	);
};

ForgetPasswordPage.propTypes = {
	history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
